module.exports = __webpack_public_path__ + "img/minasTirith-3018-07-04.0d9bddf0.jpg";